/**
 * CDN URL for product thumbnail (same rule as legacy BoardShopify).
 */
export function createProductImageUrl(product) {
  const image_width = 350;
  const image_height = 350;
  const quality = 80;
  return (
    'https://imgcdn.apm-monaco.cn/products-images/' +
    // 'https://api-asset.apmgroup.net/PIM/ProductOfficialPicture/Portrait/' +
    product.product_sku +
    '.jpg?x-oss-process=image/resize,w_' +
    image_width +
    ',h_' +
    image_height +
    '/quality,q_' +
    quality
  );
}



// WEBPACK FOOTER //
// ./src/js/utils/productImageUrl.js